import type { ReactionListResponse } from '@lens/shared';
import { apiRequest } from '../../shared/api/client.ts';

// ─── Item-level ──────────────────────────────────────────────────────────────

export async function listItemReactions(
  spaceId: string,
  itemId: string,
): Promise<ReactionListResponse> {
  return apiRequest<ReactionListResponse>(
    `/api/spaces/${spaceId}/items/${itemId}/reactions`,
    { method: 'GET' },
  );
}

export async function addItemReaction(
  spaceId: string,
  itemId: string,
  emoji: string,
): Promise<ReactionListResponse> {
  return apiRequest<ReactionListResponse>(
    `/api/spaces/${spaceId}/items/${itemId}/reactions`,
    { method: 'POST', body: { emoji } },
  );
}

export async function removeItemReaction(
  spaceId: string,
  itemId: string,
  emoji: string,
): Promise<ReactionListResponse> {
  return apiRequest<ReactionListResponse>(
    `/api/spaces/${spaceId}/items/${itemId}/reactions`,
    { method: 'DELETE', body: { emoji } },
  );
}

// ─── Comment-level ───────────────────────────────────────────────────────────

export async function addCommentReaction(
  spaceId: string,
  commentId: string,
  emoji: string,
): Promise<ReactionListResponse> {
  return apiRequest<ReactionListResponse>(
    `/api/spaces/${spaceId}/comments/${commentId}/reactions`,
    { method: 'POST', body: { emoji } },
  );
}

export async function removeCommentReaction(
  spaceId: string,
  commentId: string,
  emoji: string,
): Promise<ReactionListResponse> {
  return apiRequest<ReactionListResponse>(
    `/api/spaces/${spaceId}/comments/${commentId}/reactions`,
    { method: 'DELETE', body: { emoji } },
  );
}
